/**
 * MSAL configuration for Azure AD / Microsoft Entra ID.
 *
 * In production, values come from window.APP_CONFIG which is written by
 * entrypoint.sh at container start from Kubernetes ConfigMap env vars.
 * For local development, set REACT_APP_AZURE_* in frontend/.env.
 */
import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

// window.APP_CONFIG is populated by /env.js before React loads (see public/index.html).
const appConfig = window.APP_CONFIG || {};

const clientId =
  appConfig.AZURE_CLIENT_ID || process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId =
  appConfig.AZURE_TENANT_ID || process.env.REACT_APP_AZURE_TENANT_ID || 'common';

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    // Must be registered as a redirect URI in the Azure AD App Registration
    redirectUri: `${window.location.origin}/admin/login`,
    postLogoutRedirectUri: `${window.location.origin}/admin/login`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.debug('[MSAL]', message);
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes requested at login.
 * openid + profile + email gives us the ID token with oid, name, preferred_username.
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
